class AccountNavigation {
  constructor(account) {
    this.account = account;
    this.root = window.GkifySettings.routes.root == '/' ? '' : window.GkifySettings.routes.root;
    this.init();
  }

  init() {
    history.scrollRestoration = 'manual';

    this.navItems = document.querySelectorAll('[data-nav-item]');
    this.sections = document.querySelectorAll('[data-section]');

    // 移动端取消按钮
    addEventDelegate({
      selector: '[data-account-cancel]',
      handler: () => {
        window.location.href = `${this.root}/pages/member`;
      },
    });

    this.handleHashChange();
    window.addEventListener('hashchange', () => this.handleHashChange());

    detectMobile(({ isMobile }) => {
      if (isMobile) {
        this.account.classList.remove('g-color-footer');
      } else {
        this.account.classList.add('g-color-footer');
      }
    });
  }

  handleHashChange() {
    const hash = window.location.hash; // 例如 "#my-orders"

    // 1. 清掉所有 active 和 section
    this.navItems.forEach((item) => item.classList.remove('active'));
    this.sections.forEach((section) => (section.style.display = 'none'));

    // 2. 没有 hash:PC 跳到默认 tab,移动端啥都不做
    if (!hash) {
      const isMobile = window.matchMedia(GkifyTheme.config.mediaQueryMobile).matches;
      if (isMobile) return;
      window.location.href = `${window.location.pathname}#my-orders`;
      return;
    }

    // 3. 在 navItems 里按 href 末尾匹配 hash,兼容 "#my-orders" 和 "/pages/member#my-orders"
    let activeNavItem = null;
    this.navItems.forEach((item) => {
      const href = item.getAttribute('href') || '';
      if (href === hash || href.endsWith(hash)) {
        activeNavItem = item;
      }
    });

    if (activeNavItem) {
      activeNavItem.classList.add('active');
    }

    // 4. 显示对应 section
    try {
      const activeSection = document.querySelector(hash);
      if (activeSection) {
        activeSection.style.display = 'block';
      }
    } catch (error) {
      console.log('error', error);
    }

    // ⚠️ 注意:这里绝对不要再写
    // if (!activeNavItem) { window.location.href = `${this.root}/pages/member`; }
    // 否则匹配不到时会把 hash 清掉,看起来就是"点了没反应 / active 没加上"
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const account = document.querySelector('.g-account');
  if (account) {
    new AccountNavigation(account);
  }

  const isMobile = window.matchMedia(GkifyTheme.config.mediaQueryMobile).matches;
  if (!isMobile) return;

  const wrapper = document.querySelector('.g-account__wrapper');
  const navigation = document.querySelector('.g-account__navigation');
  const contentWrapper = document.querySelector('.g-account__content');
  const backButtons = document.querySelectorAll('.g-profile__back-btn');

  function handleNavigation() {
    const hash = window.location.hash;
    if (!hash) {
      wrapper.classList.remove('g-account__wrapper--section-active');
      navigation.style.display = 'block';
      navigation.style.width = '100%';
      contentWrapper.style.display = 'none';
    } else {
      wrapper.classList.add('g-account__wrapper--section-active');
      navigation.style.display = 'none';
      contentWrapper.style.display = 'block';
    }
  }

  window.addEventListener('hashchange', handleNavigation);
  handleNavigation();

  backButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      let root = window.GkifySettings.routes.root == '/' ? '' : window.GkifySettings.routes.root;
      window.location.href = `${root}/pages/member`;
    });
  });
});